<!--suppress UnterminatedStatementJS -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="1000px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Редактировать клиента</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{clientModel.id === null ? 'Создать' : 'Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text subheader class="content">
                    <v-container class="container-main mx-0 px-1 py-0" fluid>
                        <v-row>
                            <v-col cols="2" class="mx-0 px-0">
                                <v-list
                                        :dense="true"
                                >
                                    <v-list-item-group v-model="selectedMenu" color="primary" mandatory>
                                        <v-list-item class="ma-0 px-1">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Профиль</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Переменные</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Приглашенные</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item class="ma-0 px-1" v-show="ordersView">
                                            <v-list-item-content class="my-0 py-1">
                                                <v-list-item-title>Заказы</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                            <v-col cols="10" class="mx-0 px-0" v-show="selectedMenu === 0">
                                <v-container>
                                    <v-form
                                            ref="form"
                                            v-model="valid"
                                    >
                                        <v-row>
                                            <v-col cols="12" md12 class="py-0" v-show="clientModel.id != null">
                                                <v-text-field
                                                        v-model="clientModel.id"
                                                        readonly
                                                        label="Id в мессенджере"
                                                        class="ma-0 mt-3 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0" v-show="user.user_id === 1">
                                                <v-text-field
                                                        v-model="clientModel.answer"
                                                        label="Client answer"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.user_id"
                                                        readonly
                                                        label="Id chatway"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.first_name"
                                                        label="Имя"
                                                        class="ma-0 pa-0"
                                                        :rules="[rules.required]"
                                                        required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.last_name"
                                                        label="Фамилия"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.points"
                                                        label="Баллы"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.username"
                                                        label="Ник"
                                                        class="ma-0 pa-0"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        v-model="clientModel.created_at"
                                                        label="Дата создания"
                                                        class="ma-0 pa-0"
                                                        readonly
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="8" class="py-0" v-show="clientModel.ref !== null">
                                                <v-text-field
                                                        v-model="clientModel.ref"
                                                        label="id того кто пригласил"
                                                        class="ma-0 pa-0"
                                                        readonly
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4" class="py-0" v-show="clientModel.ref !== null">
                                                <v-btn
                                                        class="ma-0 pa-0"
                                                        small
                                                        block
                                                        @click="loadClientRef"
                                                ><span class="text-none" >Перейти</span></v-btn>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0" v-show="clientModel.ref_source !== null">
                                                <v-text-field
                                                        v-model="clientModel.ref_source"
                                                        label="Источник реферала"
                                                        class="ma-0 pa-0"
                                                        readonly
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-text-field
                                                        :value="unsubscribe_time"
                                                        label="Разрешение писать"
                                                        class="ma-0 pa-0"
                                                        readonly
                                                ></v-text-field>
                                                <v-col cols="4" md4 class="py-0 pl-7"
                                                       v-show="unsubscribe_time !== 'Бот выключен' && unsubscribe_time !== 'Разрешено'"
                                                >
                                                    <v-text-field
                                                            prepend-icon="access_time"
                                                            label="Задать время"
                                                            :value="formattedTime"
                                                            @input="changeTime"
                                                            type="time"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="3" md6 class="py-0 pl-4"
                                                       v-show="unsubscribe_time !== 'Бот выключен' && unsubscribe_time !== 'Разрешено'"
                                                >
                                                    <v-menu
                                                            ref="menu"
                                                            v-model="isActive"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            transition="scale-transition"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                    :value="formattedDate"
                                                                    label="Задать дату"
                                                                    v-on="on"
                                                                    readonly
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                                color="blue lighten-3"
                                                                :value="formattedDatePicker"
                                                                @input="changeDate"
                                                                show-current
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                            </v-col>
                                            <v-col cols="12" md12 class="py-0">
                                                <v-switch v-model="clientModel.start"
                                                          class="ma-2 pa-2 my-0 py-1"
                                                          inset
                                                          label="Первое сообщение отправлено" color="primary"
                                                          :false-value="null"
                                                          :true-value="1"
                                                          hide-details
                                                ></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-col>
                            <v-col cols="10" class="mx-0 px-0" v-show="selectedMenu === 1">
                                <variables-client
                                        :client-id="clientId"
                                        :client-model="clientModel"
                                        :selected-menu="selectedMenu"
                                ></variables-client>
                            </v-col>
                            <v-col cols="10" class="mx-0 px-0" v-show="selectedMenu === 2">
                                <invited-clients
                                        :client-id="clientId"
                                        :client-model="clientModel"
                                        :selected-menu="selectedMenu"
                                ></invited-clients>
                            </v-col>
                            <v-col cols="10" class="mx-0 px-0" v-show="selectedMenu === 3">
                                <orders-client
                                        :client-id="clientId"
                                        :client-model="clientModel"
                                        :selected-menu="selectedMenu"
                                ></orders-client>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>

    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import VariablesClient from './VariablesClient'
import InvitedClients from './InvitedClients'
import OrdersClient from './OrdersClient'

export default {
    name: 'ClientForm',
    components: {
        VariablesClient,
        InvitedClients,
        OrdersClient
    },
    props: ['dialog', 'clientId'],
    data() {
        return {
            selectedMenu: 0,
            show: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 40) || 'Максимальная длина названия 28 символов.',
                maxLengthDescription: value => (value === null || value.length <= 500) || 'Максимальная длина описания 295 символов.',
                maxLengthButton: value => (value === null || value.length <= 20) || 'Максимальная длина названия 20 символов.'
            },
            valid: false,
            clientModel: {

            },
            theDate: new Date(),
            isActive: false
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            clients: 'clients/clients',
            getClientByUserId: 'clients/getClientByUserId',
            getClientRef: 'clients/getClientRef',
            getBotById: 'bots/getBotById'
        }),
        created_at() {
            let theDate = new Date(this.clientModel.created_at * 1000)
            let date = this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
            let time = this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes()))
            return date + ' ' + time
        },
        formattedTime() {
            return this.zero(this.theDate.getHours()) + ':' + this.zero((this.theDate.getMinutes()))
        },
        formattedDatePicker() {
            return this.theDate.getFullYear() + '-' + this.zero((this.theDate.getMonth() + 1)) + '-' + this.zero(this.theDate.getDate())
        },
        formattedDate() {
            return this.zero(this.theDate.getDate()) + '.' + this.zero((this.theDate.getMonth() + 1)) + '.' + this.theDate.getFullYear()
        },
        unsubscribe_time() {
            let theDateNow = new Date()
            let date = this.zero(this.theDate.getDate()) + '.' + this.zero((this.theDate.getMonth() + 1)) + '.' + this.theDate.getFullYear()
            let time = this.zero(this.theDate.getHours()) + ':' + this.zero((this.theDate.getMinutes()))
            return this.theDate < theDateNow && this.clientModel.unsubscribe_time !== 0 ? 'Разрешено'
                : (this.clientModel.unsubscribe_time === 0 ? 'Бот выключен' : 'Бот отключен до ' + date + ' ' + time)
        },
        ordersView() {
            let bot = this.getBotById(this.$route.params['pathMatch'])
            return bot && bot.style === 'shop'
        }
    },
    methods: {
        loadClientRef() {
            this.$store.dispatch('clients/clientOne',
                { id: this.clientModel.ref, bot_id: this.clientModel.bot_id, platform: this.clientModel.platform }).then(response => {
                this.clientModel = response.response.data
            })
        },
        saveValue() {
            this.clientModel.unsubscribe_time = Date.parse(this.theDate) / 1000
            this.$store.dispatch('clients/clientUpdate', this.clientModel).then(response => {
                if (response.type === 'UpdateResult') {
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Успешно сохранено!'
                }
                this.snackbar = true
            })
        },
        loadModel(clientId) {
            if (clientId !== null) {
                this.clientModel = Object.assign({}, this.getClientByUserId(clientId))
                this.theDate = new Date(this.clientModel.unsubscribe_time * 1000)
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        changeDate(date) {
            this.isActive = false
            date = new Date(date)
            date.setHours(this.theDate.getHours())
            date.setMinutes(this.theDate.getMinutes())
            this.theDate = date
        },
        changeTime(time) {
            this.isActive = false
            let date = new Date(this.theDate)
            date.setHours(time.split(':')[0])
            date.setMinutes(time.split(':')[1])
            this.theDate = date
        }
    },
    watch: {
        dialog: {
            handler() {
                if (this.dialog === true) {
                    this.loadModel(this.clientId)
                    if (this.$route.path !== '/bot' + this.$route.params['pathMatch'] + '/client/' + this.clientId) {
                        this.$router.push({ path: '/bot' + this.$route.params['pathMatch'] + '/client/' + this.clientId })
                    }
                    this.show = true
                } else {
                    if (this.$route.path !== '/bot' + this.$route.params['pathMatch'] + '/client') {
                        this.$router.push({ path: '/bot' + this.$route.params['pathMatch'] + '/client' })
                    }
                    this.show = false
                }
            },
            deep: false,
            immediate: false
        },
        show() {
            if (this.show === false) {
                this.$refs.form.resetValidation()
                this.$emit('close')
                this.selectedMenu = 0
            }
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
